import { useEffect, useState } from "react";
import api, { fmtDT } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function OT() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [patients, setPatients] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [form, setForm] = useState({ type: "Minor Surgery", procedure: "", surgeon_id: "", patient_id: "", date: "", time: "", charges: 5000 });
  const load = () => api.get("/ot").then((r) => setRows(r.data));
  useEffect(() => { load(); api.get("/patients").then((r) => setPatients(r.data)); api.get("/doctors").then((r) => setDoctors(r.data)); }, []);
  const submit = async () => { try { await api.post("/ot", form); toast.success("OT booked"); setOpen(false); load(); } catch { toast.error("Failed"); } };

  return (
    <div className="space-y-4">
      <div className="flex justify-between"><h1 className="font-display text-2xl font-semibold">OT / Surgery</h1><Button onClick={() => setOpen(true)} className="bg-blue-700 hover:bg-blue-800 rounded-sm">+ Book OT</Button></div>
      <div className="bg-white border">
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50 text-left"><th className="label-tiny p-2">OT No</th><th className="label-tiny">Patient</th><th className="label-tiny">Surgeon</th><th className="label-tiny">Procedure</th><th className="label-tiny">Type</th><th className="label-tiny">Date</th><th className="label-tiny">Status</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b"><td className="p-2 font-mono">{r.ot_no}</td><td>{r.patient_name}</td><td>{r.surgeon_name}</td><td>{r.procedure}</td><td>{r.type}</td><td>{r.date}</td><td>{r.status}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Book OT</DialogTitle></DialogHeader>
          <div className="space-y-2">
            <select className="w-full border h-9" value={form.patient_id} onChange={(e) => setForm({ ...form, patient_id: e.target.value })}><option value="">Patient</option>{patients.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select>
            <select className="w-full border h-9" value={form.surgeon_id} onChange={(e) => setForm({ ...form, surgeon_id: e.target.value })}><option value="">Surgeon</option>{doctors.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select>
            <select className="w-full border h-9" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}><option>Minor Surgery</option><option>Major Surgery</option></select>
            <Input placeholder="Procedure" value={form.procedure} onChange={(e) => setForm({ ...form, procedure: e.target.value })} />
            <Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
            <Input placeholder="Time" value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} />
            <Input type="number" placeholder="Charges" value={form.charges} onChange={(e) => setForm({ ...form, charges: parseFloat(e.target.value) || 0 })} />
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={submit}>Book</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
